module.exports = __webpack_public_path__ + "components/Modals/LayersModal/legend.png?d1b1e3df";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/LayersModal/legend.png
// module id = 1911
// module chunks = 0